import { institutionsConstants } from "../constants/action.constants";
import { institutionService } from "../services/institutions.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const institutionActions = {
  addInstitution,
  getAllInstitutions,
  getInstitution,
  resetInstitution,
  resetAddInstitution
};

function getAllInstitutions() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await institutionService.getAllInstitutions();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_INSTITUTIONS
        )
      );
    }
  };

  function request() {
    return { type: institutionsConstants.GET_INSTITUTIONS_REQUEST };
  }
  function success(response) {
    return { type: institutionsConstants.GET_INSTITUTIONS_SUCCESS, response };
  }
  function failure(error) {
    return { type: institutionsConstants.GET_INSTITUTIONS_FAILURE, error };
  }
}

function getInstitution(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await institutionService.getInstitution(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_INSTITUTION}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: institutionsConstants.VIEW_INSTITUTION_REQUEST, id };
  }
  function success(response) {
    return { type: institutionsConstants.VIEW_INSTITUTION_SUCCESS, response };
  }
  function failure(error) {
    return { type: institutionsConstants.VIEW_INSTITUTION_FAILURE, error };
  }
}

function addInstitution(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await institutionService.addInstitution(requestBody);
      response && dispatch(success(response));
      dispatch(getAllInstitutions());
      if (requestBody.id) {
        history.push(routeConstants.INSTITUTIONS.path);
      }
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_INSTITUTION : message.ADD_INSTITUTION
        )
      );
      dispatch(resetAddInstitution());
      dispatch(resetInstitution());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_INSTITUTION : message.ADD_INSTITUTION
        )
      );
    }
  };

  function request(requestBody) {
    return { type: institutionsConstants.ADD_INSTITUTION_REQUEST, requestBody };
  }
  function success(response) {
    return { type: institutionsConstants.ADD_INSTITUTION_SUCCESS, response };
  }
  function failure(error) {
    return { type: institutionsConstants.ADD_INSTITUTION_FAILURE, error };
  }
}

function resetInstitution() {
  return { type: institutionsConstants.VIEW_INSTITUTION_RESET };
}

function resetAddInstitution() {
  return { type: institutionsConstants.ADD_INSTITUTION_RESET };
}
